module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.b1cf6a64.jpeg";